import { CalendarItemResponse } from "../contracts/CalendarItemResponse";
import { CalendarItem } from "../models/CalendarItem";

export class CalendarItemResponseMapper {
  /**
   * Converts a CalendarItemResponse to a CalendarItem model,
   * trimming the wire time (HH:mm:ss) to the UI's HH:mm shape.
   */
  toItem = (resp: CalendarItemResponse): CalendarItem => {
    return {
      bookingId: resp.bookingId,
      title: resp.title,
      instructorId: resp.instructorId,
      instructorName: resp.instructorName,
      date: resp.date,
      originalDate: resp.originalDate,
      time: resp.time.split(":").slice(0, 2).join(":"),
      timeZone: resp.timeZone,
      durationMinutes: resp.durationMinutes,
      isAllDay: resp.isAllDay,
      status: resp.status,
      reason: resp.reason,
      cancelledAt: resp.cancelledAt,
      cancelledBy: resp.cancelledBy,
      inviteeCount: resp.inviteeCount,
      visitCount: resp.visitCount,
      isRecurring: resp.isRecurring,
      capacity: resp.capacity,
      waitlistCount: resp.waitlistCount ?? 0,
    };
  };

  toItems = (responses: CalendarItemResponse[]): CalendarItem[] =>
    responses.map(this.toItem);
}
